import $ from 'jquery';

function autoAria() {
	var $contentArea = $('.l-main, .menu'),
		$breaks      = $contentArea.find('br');

	$breaks.attr('aria-hidden', 'true');
}

export { autoAria };